import { routerMiddleware } from 'connected-react-router';
import routerHistory from './history';

const connectedRouterMiddleware = routerMiddleware(routerHistory);

export default connectedRouterMiddleware;
